import { render, staticRenderFns } from "./day_study.vue?vue&type=template&id=a4fcf118&scoped=true"
import script from "./day_study.vue?vue&type=script&lang=js"
export * from "./day_study.vue?vue&type=script&lang=js"
import style0 from "./day_study.vue?vue&type=style&index=0&id=a4fcf118&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4fcf118",
  null
  
)

export default component.exports